const selectors:Record<'trigger' | 'content' | 'close', string> = {
  trigger: '[data-woo-filter-trigger]',
  content: '[data-woo-filter-content]',
  close: '[data-woo-filter-close]',
}

const states:Record<'open', string> = {
  open: 'open'
}

function init() {
  const trigger = document.querySelector(selectors.trigger) as HTMLElement;
  const content = document.querySelector(selectors.content) as HTMLElement;
  const close = document.querySelector(selectors.close) as HTMLElement;

  if (!trigger) return;

  trigger.addEventListener('click', () => {
    if (!content) return;

    content.setAttribute('data-woo-filter-content', states.open)
  })

  close.addEventListener('click', () => {
    if (!content) return;

    content.setAttribute('data-woo-filter-content', '')
  })
}

document.addEventListener(
  'DOMContentLoaded',
  async function () {
    init();
  },
  {
    once: true,
  }
);
